import React from "react";
import { ClientClipProjection } from "./ViewModels/ClientClipProjection";
import styles from "./Card.module.css";

interface ClipCardInterface {
  image?: string;
  title: string;
  subtitle?: string;
}

function _ClipCard({ title, image, subtitle }: ClipCardInterface) {
  return (
    <article className={`stack-lg ${styles.card}`}>
      {image && (
        <img src={image} alt="the clip thumbnail" className={styles.image} />
      )}
      <div className="stack-sm">
        {subtitle && <small className={styles.subtitle}>{subtitle}</small>}
        <h3 className={styles.title}>{title}</h3>
      </div>
    </article>
  );
}

function ClipCard(
  cardInterface: ClientClipProjection,
  setSelectedClip: (clip: ClientClipProjection) => void
) {
  const visualClipCard = (
    <_ClipCard
      title={cardInterface.description}
      image={cardInterface.thumbnailImageUrl}
      subtitle={`${Math.round(cardInterface.durationInSeconds / 60)} minutes`}
    />
  );

  return (
    <button
      onClick={() => {
        setSelectedClip(cardInterface);
      }}
      type="button"
      className={styles.cardButton}
    >
      {visualClipCard}
    </button>
  );
}
export default ClipCard;
